/**
 * @generated SignedSource<<5494cfbe6c69c98d2fbd4724dc0fddea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
import { FragmentRefs } from "relay-runtime";
export type EventDetailTitleRow$data = {
  readonly eventSeries: {
    readonly color: CustomColor;
    readonly name: string;
  };
  readonly " $fragmentType": "EventDetailTitleRow";
};
export type EventDetailTitleRow$key = {
  readonly " $data"?: EventDetailTitleRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailTitleRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailTitleRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "35b9536f35bac229a9d13e59fc2c6e19";

export default node;
